"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var version_1 = require("./version");

var wrap_1 = tslib_1.__importDefault(require("./wrap"));

exports.default = {
  useWrap: wrap_1.default,
  isVue3: version_1.isVue3
};